import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { formatDuration } from "../../lib/format";
import { normalizeImageUrl } from "../../lib/imageUrl";
import PublicNav from "../../components/PublicNav";
import Footer from "../../components/Footer";
import NewsletterCTA from "../../components/NewsletterCTA";
import Seo from "../../components/Seo";

export default function ToursIndex() {
  const [tours, setTours] = useState([]);
  const [s, setS] = useState({});
  useEffect(() => {
    api.get("/tours?active_only=true").then(r => setTours(r.data));
    api.get("/public/home-settings").then(r => setS(r.data || {})).catch(() => {});
  }, []);

  return (
    <div className="public-shell">
      <Seo
        title="All Mystery Tours"
        description="Browse every immersive mystery tour Mystery Served offers in St. Petersburg, FL. Pick your case, gather your party, and turn the city into your playground."
        url="https://mysteryserved.com/tours"
      />
      <PublicNav />
      <section className="bg-ms-cream pt-32 pb-12">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="label-eyebrow text-ms-brass">{s.tours_index_eyebrow || "All experiences"}</p>
          <h1 className="serif text-ms-ink text-5xl md:text-7xl mt-4 leading-[0.95]">{s.tours_index_headline || "Tours."}</h1>
          <p className="mt-6 text-ms-stone max-w-xl text-base leading-[1.7] whitespace-pre-line">
            {s.tours_index_subtitle || "Each tour keeps its own world — its own venues, food, and unfolding mystery. Pick the date and time that suits your party."}
          </p>
        </div>
      </section>

      <section className="bg-ms-cream pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {tours.length === 0 ? (
            <div className="bg-ms-ivory border border-ms-edge rounded-sm p-16 text-center mt-12">
              <p className="serif text-3xl text-ms-ink">Coming soon.</p>
              <p className="mt-3 text-ms-stone text-sm">New tours are being curated.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 mt-12">
              {tours.map((t) => (
                <Link key={t.id} to={`/tour/${t.slug}`} className="group block" data-testid={`tour-list-${t.slug}`}>
                  <div className="relative aspect-[4/3] overflow-hidden bg-ms-clay rounded-sm">
                    {t.hero_image && <img src={normalizeImageUrl(t.hero_image)} alt={t.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />}
                    <div className="absolute top-4 left-4 bg-ms-ink text-ms-cream px-3 py-1.5 rounded-full label-eyebrow text-[10px] shadow-lg">
                      From ${t.base_price}
                    </div>
                  </div>
                  <div className="mt-7">
                    <p className="label-eyebrow text-ms-brass text-[10px]">{t.difficulty} · {formatDuration(t)}</p>
                    <h3 className="serif text-ms-ink text-3xl md:text-4xl mt-3 group-hover:text-ms-brass transition-colors">{t.title}</h3>
                    {t.tagline && <p className="serif italic text-ms-stone text-xl mt-2">{t.tagline}</p>}
                    <p className="text-ms-stone text-base mt-4 leading-[1.7] line-clamp-2">{t.short_description}</p>
                    <div className="mt-6 flex items-baseline justify-between gap-3">
                      <p className="text-ms-ink">
                        <span className="serif text-2xl text-ms-brass">${t.base_price}</span>
                        <span className="text-ms-stone text-xs ml-2">per guest</span>
                      </p>
                      <span className="label-eyebrow text-xs text-ms-ink group-hover:text-ms-brass border-b border-ms-brass pb-1">Explore →</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
      <NewsletterCTA />
      <Footer />
    </div>
  );
}
